import React from "react"

export default function() {
  return <svg style={{width: "0.8em", height: "0.8em", alignSelf: "center", verticalAlign: "center"}} fill="currentColor" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.8 11.6L5.8.1c-.2-.2-.5-.1-.7.1-.2.2-.1.5.1.7L17.7 12 5.2 23.1c-.2.2-.2.5 0 .7 0 .1.2.2.3.2.1 0 .2 0 .3-.1l13-11.5c.1-.1.2-.2.2-.4s-.1-.3-.2-.4z"/></svg>
}
